interface MemoryQueryResponse<T> {
  ok: boolean
  status: number
  data: T
}

export async function postMemoryQuery<T>(url: string, body: Record<string, unknown>, signal: AbortSignal): Promise<MemoryQueryResponse<T>> {
  const request = (): RequestInit => ({
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify(body),
    signal,
  })
  let response = await fetch(url, request())

  // A long-lived Inertia page can retain a masked token from before the Rails
  // session rotated. Rails returns the replacement token so this safe,
  // read-only POST can recover without presenting a false integration error.
  const refreshedToken = response.status === 422 ? response.headers.get('X-CSRF-Token') : null
  if (refreshedToken) {
    syncCsrfToken(refreshedToken)
    response = await fetch(url, request())
  }

  return {
    ok: response.ok,
    status: response.status,
    data: await response.json() as T,
  }
}

function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ''
}

function syncCsrfToken(token: string) {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]') || document.head.appendChild(document.createElement('meta'))
  meta.name = 'csrf-token'
  meta.content = token
}
